import { NgModule } from '@angular/core';
import {
    ConfigModule,
    ProductAdapter,
    provideDefaultConfig,
} from '@spartacus/core';
import { OutletPosition, provideOutlet } from '@spartacus/storefront';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { AccOverviewPlaceholderComponent } from './account-overview/account-overview/acc-overview-placeholder/acc-overview-placeholder.component';
import { AccOverviewPlaceholder1Component } from './account-overview/account-overview/acc-overview-placeholder1/acc-overview-placeholder1.component';
import { AccountOverviewComponent } from './account-overview/account-overview/account-overview.component';
import { ImportCartComponentAcc } from './account-overview/account-overview/import-cart/import-cart.component';
import { CustomAddToCartComponent } from './custom-add-to-cart/custom-add-to-cart/custom-add-to-cart.component';
import { ImportCartComponent } from './custom-add-to-cart/import-cart/import-cart.component';
import { MiniCartComponent } from './custom-add-to-cart/mini-cart/mini-cart.component';
import { InfluenzaDashboardComponent } from './custom-influenza/influenza-dashboard/influenza-dashboard.component';
import { CustomOccProductAdapter } from './custom-pdp/custom-pdp.adapter';
import { CustomPdpConfig } from './custom-pdp/custom-pdp.config';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        CustomBanner: {
          module: () =>
            import('./custom-banner/custom-banner.module').then(
              (m) => m.CustomBannerModule
            ),
          cmsComponents: [
            'SimpleResponsiveBannerComponent',
            'BannerComponent',
            'SimpleBannerComponent',
          ],
        },
        Influenza: {
          module: () =>
            import('./custom-influenza/custom-influenza.module').then(
              (m) => m.CustomInfluenzaModule
            ),
          cmsComponents: [
            'SelectVaccinePageComponent',
            'FluviewCheckoutPageComponent',
            'FluCartMarketBannerComponent',
            'FluviewCartPageComponent',
            'SanofiFluDashboardBannerComponent',
            'SanofiFluDashboardAlertBannerComponent',
            'FluParagraphComponent',
            'FluviewOrderConfirmationPageComponent',
            'FlureservationOverViewPageComponent',
          ],
        },
      
        PDP: {
          module: () =>
            import('./custom-pdp/custom-pdp.module').then(
              (m) => m.CustomPdpModule
            ),
          cmsComponents: ['ProductIntroComponent'],
        },
        ProfilePreferences: {
          module: () =>
            import(
              './custom-profile-and-preferences/custom-profile-and-preferences.module'
            ).then((m) => m.CustomProfileAndPreferencesModule),
          cmsComponents: ['AccountProfilePreferenceComponent'],
        },
        ForgotPassword: {
          module: () =>
            import('./forgot-user-password/forgot-user-password.module').then(
              (m) => m.ForgotUserPasswordModule
            ),
          cmsComponents: [
            'LoginHelpComponent',
            'UserNameRecoverySuccessComponent',
            'HintQuestionAnswerComponent',
            'ForgotPasswordComponent',
            'LoginPageReferenceComponent',
          ],
        },
        OrderHistory: {
          module: () =>
            import('./order-history/order-history.module').then(
              (m) => m.OrderHistoryModule
            ),
          cmsComponents: [
            'AccountOrderHistoryComponent',
            'AccountOrderDetailsOverviewComponent',
            'OrderHistoryBannerComponent',
          ],
        },
        Checkout: {
          module: () =>
            import('./shared/modules/checkout/checkout.module').then(
              (m) => m.CheckoutModule
            ),
          cmsComponents: ['checkoutPage'],
        },
        SwitchWhsPopUp: {
          module: () =>
            import(
              './shared/modules/switch-whs-popup/select-whs-popup.module'
            ).then((m) => m.SelectWhsPopupModule),
          cmsComponents: ['SwitchWhsPopupComponent'],
        },
        Statements: {
          module: () =>
            import('./statements/statements.module').then(
              (m) => m.StatementsModule
            ),
          cmsComponents: ['StatementTopBodyComponent'],
        },
      },
    }),
  ],
  providers: [
    // Account Overview Outlets
    provideOutlet({
      id: 'AccountOverviewPlaceholderSlot',
      position: OutletPosition.REPLACE,
      component: AccOverviewPlaceholderComponent,
    }),
    provideOutlet({
      id: 'AccountOverviewPlaceholderSlot2',
      position: OutletPosition.BEFORE,
      component: AccOverviewPlaceholder1Component,
    }),
    provideOutlet({
      id: 'AccountOverviewOrdersSlot',
      position: OutletPosition.REPLACE,
      component: AccountOverviewComponent,
    }),
    provideOutlet({
      id: 'importCartPositionForAcc',
      position: OutletPosition.REPLACE,
      component: ImportCartComponentAcc,
    }),
    // Add To Cart Outlets
    provideOutlet({
      id: 'EmptyCartMiddleContent',
      position: OutletPosition.REPLACE,
      component: CustomAddToCartComponent,
    }),
    provideOutlet({
      id: 'importCartPosition',
      position: OutletPosition.REPLACE,
      component: ImportCartComponent,
    }),
    provideOutlet({
      id: 'MiniCart',
      position: OutletPosition.REPLACE,
      component: MiniCartComponent,
    }),
    // Influenza Outlets
    provideOutlet({
      id: 'FluParaMiddleSlottest',
      position: OutletPosition.REPLACE,
      component: InfluenzaDashboardComponent,
    }),
    provideCharts(withDefaultRegisterables()),
    // PDP
    { provide: ProductAdapter, useClass: CustomOccProductAdapter },
    provideDefaultConfig(CustomPdpConfig),
  ],
})
export class AppLazyModule {}
